/**
 * In-memory token store for the portal self-fulfillment QR flow.
 *
 * Key:   token string (e.g. "m5fgk3-ab7x2")
 * Value: {
 *   orderId:       string,
 *   ticketNumber:  string,
 *   partNumber:    string,
 *   partDescription: string,
 *   locationName:  string,
 *   serialNumber:  string,
 *   pin:           string,   // 4-digit PIN
 *   photoDataUrl:  string|null,
 *   uploadedAt:    string|null,  // ISO timestamp
 * }
 *
 * Shared between PortalSelfFulfillModal (writer + poller)
 * and PortalVerifyPage (reader + photo writer).
 * Resets on page reload — consistent with Phase 2 mock-data pattern.
 */
export const fulfillmentTokens = new Map();
